import Component from "flarum/common/Component";
import Button from "flarum/common/components/Button";
import { t } from "../api";
export default class FactGallery extends Component {
  index = 0;
  focused = false;
  view() {
    const story = this.attrs.story;
    this.index = Math.min(this.index, Math.max(0, story.images.length - 1));
    if (!this.attrs.viewer) return m("div", {
      className: "FactDetail-media Fact-gradient--" + story.background
    }, story.images.map((image, i) => m("img", {
      key: image.path,
      src: image.url,
      alt: story.author.name + " · " + (i + 1),
      loading: "lazy"
    })), story.content && m("p", null, story.content));
    const current = story.images[this.index];
    return m("div", {
      className: "FactGallery " + (current ? "FactGallery--images" : "FactGallery--text") + (this.focused ? " FactGallery--focused" : "")
    }, m("div", {
      className: "FactGallery-backdrop Fact-gradient--" + story.background,
      "aria-hidden": "true"
    }, current && m("img", {
      src: current.url,
      alt: "",
      loading: "lazy"
    })), current ? m("div", {
      className: "FactGallery-content"
    }, m("div", {
      className: "FactGallery-collage FactGallery-collage--" + story.images.length
    }, story.images.map((image, i) => m("button", {
      key: image.path,
      type: "button",
      "aria-label": String(t("open_image")) + " " + (i + 1),
      onclick: () => {
        this.index = i;
        this.focused = true;
      }
    }, m("img", {
      src: image.url,
      alt: story.author.name + " · " + (i + 1),
      loading: "lazy"
    })))), m("div", {
      className: "FactGallery-slide"
    }, m("img", {
      src: current.url,
      alt: story.author.name + " · " + (this.index + 1),
      loading: "lazy"
    })), story.images.length > 1 && m("div", {
      className: "FactGallery-controls"
    }, m(Button, {
      className: "Button Button--icon",
      icon: "fas fa-chevron-left",
      "aria-label": t("previous_image"),
      disabled: this.index === 0,
      onclick: () => this.index--
    }), m("span", {
      "aria-live": "polite"
    }, this.index + 1, " / ", story.images.length), m(Button, {
      className: "Button Button--icon",
      icon: "fas fa-chevron-right",
      "aria-label": t("next_image"),
      disabled: this.index === story.images.length - 1,
      onclick: () => this.index++
    })), m(Button, {
      className: "Button FactGallery-grid",
      onclick: () => this.focused = false
    }, t("all_images"))) : m("div", {
      className: "FactGallery-text Fact-gradient--" + story.background
    }, m("p", null, story.content)));
  }
}
flarum.reg.add('xgay-fact', 'common/components/FactGallery', FactGallery);